import { Component, Output, Input, OnInit, EventEmitter, OnDestroy } from '@angular/core';
import { AbstractControlDirective, AbstractControl } from '@angular/forms';
import { Translation } from '../../providers/translation';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs/Observable';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { first, tap, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'image-import',
  templateUrl: './image_import.component.html',
  styles: [
    `
  label { overflow: hidden;}
  .btn-file {
    min-height: 35px;
  }
  .error {
    color: #e74c3c;
  }
  .img_preview {
    max-height: 200px;
    max-width: 100%;
    margin: 15px 0;
  }
  .fa-upload {
    padding-right: 10px;
  }

  `
  ]
})
export class ImageImportComponent implements OnInit, OnDestroy {
  @Input() public title: string = 'tags.edit.upload_label';
  @Input() completions;
  @Input('imgPreview')
  set imgPreview(val: string) {
    this.imagePreviewUrl = val;
  }
  get imgPreview() {
    return this.imagePreviewUrl;
  }

  @Output() private import: EventEmitter<any> = new EventEmitter<any>();

  public error: string = '';
  public imagePreviewUrl: string = '';
  constructor(private translateService: TranslateService) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.import.complete();
  }
  importImage($ev: any) {
    this.error = '';
    const file: File = $ev.target.files[0];
    if (!file) return;
    // allow images below 5Mb
    if (file.size >= 5242880) {
      return (this.error = this.translateService.instant('action.imageBig'));
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    const onLoadEnd = (next: ProgressEvent) => {
      const target: any = next.target;
      const b64image: string = target.result;
      this.import.emit({ name: file.name, data: b64image });
    };
    const fileReader$ = fromEvent(reader, 'loadend');
    fileReader$.pipe(first(), tap(onLoadEnd)).subscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/image_import/image_import.component.ts